import React from 'react'
import { Element as ScrollElement } from 'react-scroll'
import { MenuList } from './Menu'

export const PopularItems = ({
  addFavoriteStart,
  availableFavorites,
  deleteFavoriteStart,
  favorites,
  menuItemIdsLoading,
  popularItems,
  onSelectMenuItem,
}) => (
  <ScrollElement name="popularitems">
    <section id="menu-section-popularItems">
      <section className="placeorder">
        <div className="placeorder-menu">
          <h2 className="popularItemsHeader">Popular Items</h2>
          <p className="placeorder-description">
            Choose from the top items at your building
          </p>
          <MenuList
            addFavoriteStart={addFavoriteStart}
            availableFavorites={availableFavorites}
            deleteFavoriteStart={deleteFavoriteStart}
            favorites={favorites}
            items={popularItems}
            menuItemIdsLoading={menuItemIdsLoading}
            onSelectMenuItem={onSelectMenuItem}
          />
        </div>
      </section>
    </section>
  </ScrollElement>
)
export default PopularItems
